import { message } from "antd";
import axios from "axios";
import { get, isEmpty } from "lodash";

import { host } from "config";
import { defaultHeaders } from "shared/method";
import { roughLogOut } from "../session";
import {
  BULK_CREATE,
  BULK_DELETE,
  BULK_UPDATE,
  COUNT,
  CREATE,
  DELETE,
  GET,
  GET_LIST,
  GET_ONE,
  UPDATE
} from "./requestType";

const getOptionByType = (type = GET, resource = "", param = {}, options = {}) => {
  let option = { url: "", method: "" };
  switch (type) {
    case GET:
      option.method = "GET";
      option.url = `${host}/${resource}`;
      break;
    case GET_LIST:
      option.method = "GET";
      option.url = `${host}/${resource}`;
      break;
    case GET_ONE:
      option.method = "GET";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}`;
      break;
    case BULK_CREATE:
      option.method = "POST";
      option.url = `${host}/${resource}s`;
      break;
    case UPDATE:
      option.method = "PUT";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case BULK_UPDATE:
      option.method = "PATCH";
      option.url = `${host}/${resource}/bulkupdate`;
      break;
    case DELETE:
      option.method = "DELETE";
      option.url = `${host}/${resource}/${param.id}`;
      break;
    case BULK_DELETE:
      option.method = "DELETE";
      option.url = `${host}/${resource}/bulkdelete`;
      break;
    case COUNT:
      option.method = "GET";
      option.url = `${host}/${resource}/count`;
      break;
    default:
      return {};
  }

  switch (option.method) {
    case "GET":
      option.params = param;
      break;
    case "POST":
      option.data = param.body;
      break;
    case "PATCH":
    case "PUT":
      option.data = param.body;
      break;
    case "DELETE":
      break;
    default:
      option.params = param;
      option.data = param.body;
      break;
  }

  if (options.path) option.url = `${host}/${options.path}`;
  return option;
};

export const dataProvider = (type, resource, params, options) => {
  const option = getOptionByType(type, resource, params, options);
  if (isEmpty(option)) throw Error("no match request type");

  return axios({
    ...option,
    headers: defaultHeaders()
  })
    .then((res) => {
      if (get(res, "data.error", get(res, "data.err")))
        return {
          err: true,
          message: get(res, "data.error.msg", "錯誤")
        };

      if ([CREATE, UPDATE, DELETE, BULK_CREATE, BULK_DELETE, BULK_UPDATE].indexOf(type) >= 0) {
        message.destroy();
        message.success("成功");
      }

      return res;
    })
    .catch((error) => {
      const status = get(error, "response.status");
      const data = get(error, "response.data");
      if (!error || status === 401) {
        roughLogOut();
        return;
      }

      message.destroy();
      message.error(data || "錯誤");
      return {
        err: true,
        status,
        message: data || error.message
      };
    });
};
